export enum ViewType {
    Desktop = 0,
    Mobile = 1,
    Android = 2,
    Ios = 3,
    WindowsPhone = 4
}


// WEBPACK FOOTER //
// ./app/objects/users/viewType.ts